import moment from 'moment';

export const formatDateAsString = date => moment(date).format('YYYY-MM-DD');
export const getTodayLocal = () => moment().format('YYYY-MM-DD');
